import React from 'react';
import { INPUT_HEIGHT, TextInput, Props as TextInputProps } from './text-input';
import { StyleSheet } from 'react-native';

export const CONTAINER_PADDING_VERTICAL = 32;

export const TextArea: React.FC<TextInputProps> = (props) => {
  const { containerStyle, label, numberOfLines = 5, style, value } = props;
  return (
    <TextInput
      {...props}
      containerStyle={[
        styles.container,
        {
          height: numberOfLines * INPUT_HEIGHT + CONTAINER_PADDING_VERTICAL,
        },
        containerStyle,
      ]}
      label={value ? label : null}
      multiline
      numberOfLines={numberOfLines}
      style={[styles.input, style]}
      textAlignVertical="top"
    />
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 12,
  },
  input: {
    flex: 1,
  },
});
